module.exports = __webpack_public_path__ + "img/logo-kid.683cb081.svg";